import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { sortByNames } from '../array/sorters';
import { getMVKHouseById } from '../mvk_data';
export function getSectionInHouse(MVKData, houseId, sectionId) {
  if (!houseId || !sectionId) {
    return undefined;
  }
  var selectedHouse = getMVKHouseById(MVKData, houseId);
  return selectedHouse && selectedHouse.sections.find(function (section) {
    return section.id === sectionId;
  });
}
export function getFloorScheme(MVKData, houseId, sectionId, floorFilter) {
  var selectedSection = getSectionInHouse(MVKData, houseId, sectionId);
  return selectedSection && selectedSection.floorPlans.find(function (floorPlan) {
    return !!floorFilter && floorPlan.floors.includes(floorFilter);
  });
}
export function getFloorsInSection(MVKData, houseId, sectionId) {
  if (!houseId || !sectionId) {
    return [];
  }
  var selectedHouse = getMVKHouseById(MVKData, houseId);
  var selectedSection = selectedHouse && selectedHouse.sections.find(function (section) {
    return section.id === sectionId;
  });
  var floors = selectedSection && selectedSection.floorPlans.reduce(function (acc, floorPlan) {
    return acc.concat(floorPlan.floors);
  }, []);
  return _toConsumableArray(new Set(floors)).sort(function (prev, next) {
    return prev - next;
  });
}
export var getSectionViewModelsByStatus = function getSectionViewModelsByStatus(array, label) {
  return array.filter(function (item) {
    return item.deadlineData.text === label;
  });
};
export var getSectionViewModelsSortedByNames = function getSectionViewModelsSortedByNames(source) {
  var types = _toConsumableArray(new Set(source.map(function (item) {
    return item.deadlineData.text;
  })));
  return types.reduce(function (acc, type) {
    var sectionsGroup = getSectionViewModelsByStatus(source, type).sort(sortByNames);
    return acc.concat(sectionsGroup);
  }, []);
};
export function getSectionByOfferId(MVKData, offerId) {
  var offer = MVKData.offers.find(function (o) {
    return o.id === offerId;
  });
  var house = offer && MVKData.houses.find(function (h) {
    return h.id === offer.houseId;
  });
  return offer && house && house.sections.find(function (s) {
    return Boolean(s.number && offer.sectionNumber && s.number === offer.sectionNumber);
  });
}
export function getHouseBySectionId(MVKData, sectionId) {
  return MVKData.houses.find(function (h) {
    return h.sections.some(function (s) {
      return s.id === sectionId;
    });
  });
}